// extracted by mini-css-extract-plugin
export var option = "_cv-0";
export var optionCard = "_cv-f";
export var optionContent = "_cv-g";
export var optionIcon = "_cv-i";
export var optionIconBox = "_cv-h";
export var optionLabel = "_cv-j";
export var optionPill = "_cv-m";
export var optionPillBadge = "_cv-p";
export var optionPillIcon = "_cv-n";
export var optionPillLabel = "_cv-o";
export var optionRadio = "_cv-k";
export var optionRadioInner = "_cv-l";
export var optionReveal = "_cv-2";
export var optionRevealDelay0 = "_cv-3";
export var optionRevealDelay1 = "_cv-4";
export var optionRevealDelay10 = "_cv-d";
export var optionRevealDelay11 = "_cv-e";
export var optionRevealDelay2 = "_cv-5";
export var optionRevealDelay3 = "_cv-6";
export var optionRevealDelay4 = "_cv-7";
export var optionRevealDelay5 = "_cv-8";
export var optionRevealDelay6 = "_cv-9";
export var optionRevealDelay7 = "_cv-a";
export var optionRevealDelay8 = "_cv-b";
export var optionRevealDelay9 = "_cv-c";
export var optionSelected = "_cv-1";